import React, {
  ComponentPropsWithoutRef,
  ElementType,
  ReactElement,
  ReactNode,
} from 'react';
import { isPermitted } from '@plerionhq/design-system';
import { useUserProfile } from '../../../api/profile';

import { useTranslation } from 'react-i18next';

export type ProtectedComponentProps<T extends ElementType> = {
  /**
   * Component to be rendered as. Default: "button"
   */
  as?: T;
  /**
   * Appends class names to the existing class name string
   */
  children?: ReactNode;
  permission: string | string[];
  every?: boolean;
  disabled?: boolean;
};

export function ProtectedComponent<T extends ElementType>({
  permission,
  children,
  disabled,
  every = false,
  as,
  ...props
}: ProtectedComponentProps<T> &
  Omit<
    ComponentPropsWithoutRef<T>,
    keyof ProtectedComponentProps<T>
  >): ReactElement {
  const { t } = useTranslation('containerInterface');
  const { data, status } = useUserProfile();
  if (disabled) {
    return <>{children}</>;
  }

  if (status === 'pending') {
    return <div>{t('common:loading')}</div>;
  }
  if (status === 'error') {
    return <div>{t('common:somethingWentWrong')}</div>;
  }
  const permissions = data?.permissions || [];
  if (isPermitted(permissions, permission, every)) {
    const Component = as || React.Fragment;
    return <Component {...props}>{children}</Component>;
  }
  return <></>;
}
